import { connect } from "react-redux";
import { MovViewProps, mapDispatchToMovProps, mapStateToMovProps, movController } from "../mov.controll";
import { FilterMovParams, GroupMovimentacaoBySituacao, intialValueMovimentacao, Movimentacao } from "../mov.model";
import { Select as ViewList } from "../../../components/select";
import { Box, Card, CardActionArea, CardContent, CardHeader, Chip, Grid, Stack, Typography } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import { memo, useCallback, useEffect, useState } from "react";
import { MovCadastro } from "./mov.cad";
import { formatData, formatMoney, getDataText, listDataText } from "../../../services/utils";
import { FechamentoMov, Pessoa, TipoMovDesc } from "../../../data.types";
import { useTheme } from "@emotion/react";
import { Adb, Android, Close, DoNotDisturb, ListAlt, Search, SecurityUpdate, SmartToy, Storefront } from "@mui/icons-material";
import SelecionarFuncionario from "../../funcionario/view/funcionario.select";
import { configController } from "../../config/config.controll";
//import { navigationToMovCadastroView } from "../../tipoMov/tipomov.router"
import { MovCadastroView } from "./mov.cad";
import store from "../../../store";

export const getDescPagamento = (row: FechamentoMov) => {
    let pags = "";
    for (let i = 0; i < row.pagamentos.length; i++) {
        const mp = row.pagamentos[i];
        pags = pags + mp.descricao + " " + formatMoney(mp.valor)
        if (i < row.pagamentos.length)
            pags = pags + " | "
    }
    return pags
}
const columnsVenda: GridColDef[] = [
    { field: 'codigo', headerName: 'Código', flex: 1 },
    { field: 'created_at', headerName: 'Data', flex: 2, renderCell: (prm) => formatData(prm.value) },
    { field: 'pessoa.nome', headerName: 'Cliente', flex: 3, valueGetter: (value, row: Movimentacao) => row.pessoa.nome },
    { field: 'situacao', headerName: 'Situação', flex: 2 },
    { field: 'fechamento.pagamentos', headerName: 'Pagamentos', flex: 2, valueGetter: (value, row: Movimentacao) => getDescPagamento(row.fechamento) },
    { field: 'fechamento.total', headerName: 'Total', flex: 2, valueGetter: (value, row: Movimentacao) => formatMoney(row.fechamento.total) },
]

const getColumLocal = (value:any) => {
    switch(value){
        case "loja":return <Storefront titleAccess="Loja" color="info" />;
        case "app" :return <SecurityUpdate titleAccess="Aplicativo" color="success" />;
        case "bot" :return <Android titleAccess="IA Agente" color="warning"/>;
        default: return <DoNotDisturb titleAccess="Não Definido" color="secondary" />;
    }
}

const columnsPedido: GridColDef[] = [
    { field: 'local', headerName: 'Origem', flex: 1, renderCell:(prm)=> getColumLocal(prm.value)},
    { field: 'codigo', headerName: 'Código', flex: 1 },
    { field: 'created_at', headerName: 'Data', flex: 2, renderCell: (prm) => formatData(prm.value) },
    { field: 'pessoa.nome', headerName: 'Cliente', flex: 3, valueGetter: (value, row: Movimentacao) => row.pessoa.nome },
    { field: 'canal_dist', headerName: 'Entregador', flex: 2, valueGetter: (value, row: Movimentacao) => row.canal_dist?._id ? row.canal_dist?.funcionario.nome : "Aguardando entrega..." },
    { field: 'fechamento.pagamentos', headerName: 'Pagamentos', flex: 2, valueGetter: (value, row: Movimentacao) => getDescPagamento(row.fechamento) },
    { field: 'fechamento.total', headerName: 'Total', flex: 2, valueGetter: (value, row: Movimentacao) => formatMoney(row.fechamento.total) },
]

const columnsCompra: GridColDef[] = [
    { field: 'codigo', headerName: 'N° Nota', flex: 2 },
    { field: 'created_at', headerName: 'Data', flex: 2, renderCell: (prm) => formatData(prm.value) },
    { field: 'pessoa.nome', headerName: 'Fornecedor', flex: 4, valueGetter: (value, row: Movimentacao) => row.pessoa.nome },
    { field: 'situacao', headerName: 'Status', flex: 2 },
    { field: 'fechamento.total', headerName: 'Total', flex: 2, valueGetter: (value, row: Movimentacao) => formatMoney(row.fechamento.total) },
]

const columnsAvaria: GridColDef[] = [
    { field: 'codigo', headerName: 'Código', flex: 2 },
    { field: 'created_at', headerName: 'Data', flex: 2, renderCell: (prm) => formatData(prm.value) },
    { field: 'pessoa.nome', headerName: 'Funcionario', flex: 4, valueGetter: (value, row: Movimentacao) => row.pessoa.nome },
    { field: 'situacao', headerName: 'Status', flex: 2 },
    { field: 'fechamento.total', headerName: 'Total', flex: 2, valueGetter: (value, row: Movimentacao) => formatMoney(row.fechamento.total) },
]

const listDataOpt = listDataText();

function MovList(props: MovViewProps) {
    const { movActions, movState, tipoMovState, funcionarioActions, clienteActions, fornecedorActions } = props
    const { error, loading, loadingRows, msg, row, rows, showAlert, showDialogExluir, status, showCadModal, changeList, rowsGroupBySituacao, filtro, rowGroup } = movState
    const { create, read, readView, update, deletar, set, get, setShowAlert, setShowDialogExluir, setClearValue, setShowCadModal, setFiltro, setRowsMovGroup } = movActions

    const [showFormFiltro, setShowFormFiltro] = useState(false)
    const [hiddenFieldDataFiltro, setHiddenFieldDataFiltro] = useState(true);
    const theme = useTheme()
    console.log("stateMOv", props.movState);
    useEffect(() => {
        handleRead();
    }, [tipoMovState.row._id])


    const handleRead = () => {
        setFiltro({
            ...filtro,
            tipoMov: tipoMovState.row.descricao
        })
    }


    const handleSetRowsGroup = (rowsGroup: GroupMovimentacaoBySituacao) => {
        setRowsMovGroup(rowsGroup);
    }

    const handleNovo = () => {
        console.log("handleNovo configControler", configController.state.row)
        let newMov:Movimentacao = {
            ...structuredClone(intialValueMovimentacao),
            tipo_mov: tipoMovState.row,
            created_at: new Date().toISOString(),
            local: "loja",
        };
        
        switch (tipoMovState.row.descricao) {
            case TipoMovDesc.COMPRA:
                set(newMov)
                setShowCadModal(true)
                fornecedorActions.setShowSelectModal(true);
                break;
            case TipoMovDesc.PEDIDO:
                set(newMov)
                setShowCadModal(true)
                //navigationToMovCadastroView()
                clienteActions.setShowSelectModal(true);
                break;
            case TipoMovDesc.AVARIA:
                set(newMov)
                setShowCadModal(true)
                funcionarioActions.setShowSelectModal(true);
                break;
            default:
                //venda processo é diferente por causa do canal de distribuicao relacionado
                props.movActions.newMovVenda()
                break;
        }
        
    }

    const handleAlterar = (row: any) => {
        set(row);
        setShowCadModal(true)
    }

     const handleCloseCadastro = () => {
        setShowCadModal(false)
        setRowsMovGroup({ situacao: "", rows: [] })
    }

     const Cadastro = useCallback(() => {
        return MovCadastro({
            ...props,
            handleCloseView: handleCloseCadastro,
        }).renderModal({
            handleClose: handleCloseCadastro,
            show: showCadModal,
            width: "xl",
            heigth: "100%",
        })
    },[row._rev, showCadModal])

    const getColumn = () => {
        switch (tipoMovState.row.descricao) {
            case TipoMovDesc.COMPRA:
                return columnsCompra;
            case TipoMovDesc.AVARIA:
                return columnsAvaria;
            case TipoMovDesc.PEDIDO:
                return columnsPedido;
            case TipoMovDesc.VENDA:
                return columnsVenda;
            default:
                return columnsVenda;
        }
    }

    const GridStatusMov = () => {
        return (
            <Grid
                container
                spacing={2}
                columns={12}
                sx={{ mb: (theme) => theme.spacing(2) }}
            >

                {rowsGroupBySituacao.map((rowGr, idx) => (
                    <Grid key={idx} size={{ xs: 12, sm: 6, lg: 3 }}>
                        <Card variant="highlighted" sx={{ height: '100%', flexGrow: 1 }}>
                            <CardActionArea
                                onClick={() => handleSetRowsGroup(rowGr)}
                                data-active={rowGr.situacao === rowGroup.situacao ? '' : undefined}
                                sx={{
                                    height: '100%',
                                    '&[data-active]': {
                                        backgroundColor: 'action.selected',
                                        borderColor: "aquamarine",
                                        '&:hover': {
                                            backgroundColor: 'action.selectedHover',
                                        },
                                    },
                                }}
                            >
                                <CardContent>
                                    <Stack
                                        direction="column"
                                        sx={{ justifyContent: 'space-between', flexGrow: '1', gap: 1 }}
                                    >
                                        <Stack sx={{ justifyContent: 'space-between' }}>
                                            <Stack
                                                direction="row"
                                                sx={{ justifyContent: 'space-between', alignItems: 'center' }}
                                            >
                                                <Typography variant="subtitle1" component="p">
                                                    {rowGr.situacao}
                                                </Typography>
                                                <Chip color={rowGr.situacao === "ABERTO" ? "warning" : rowGr.situacao === "ENTREGA" ? "info" : "success"} label={rowGr.rows.length} />
                                            </Stack>
                                        </Stack>
                                        <Box sx={{ width: '100%', height: 30 }}>
                                            <Typography variant="h4" component="p">
                                                {formatMoney(rowGr.rows.map(mov => mov.fechamento.total).reduce((a, b) => a + b, 0))}
                                            </Typography>
                                        </Box>

                                    </Stack>

                                </CardContent>


                            </CardActionArea>
                        </Card>

                    </Grid>
                ))}
            </Grid>

        )
    }

    const handleMutatorFiltro = ([value, field]: any, state: any, { changeValue }: any) => {
        console.log("field", field)
        console.log("value", value)
        var label = "";
        if (field === "opt_data_select") {
            console.log("existe definir",String(value['label']).toLowerCase().includes("definir",0))
            
            if (String(value['label']).toLowerCase().includes("definir",0)) {//verifica se é um valor personalizado
                //changeValue(state, 'dtIni', () => value['value']['dtIni']);
                //changeValue(state, 'dtFim', () => value['value']['dtFim']);
                //changeValue(state, 'show_data_label', () => value['label']);
                //changeValue(state, 'show_data_label', () => "De: " + getDataText(value['value']['dtIni']) + " Até: " + getDataText(value['value']['dtFim']));
                label = "De: " + getDataText(value['value']['dtIni']) + " Até: " + getDataText(value['value']['dtFim'])                
                setHiddenFieldDataFiltro(false);
            } else {
                label = value['label'];
                setHiddenFieldDataFiltro(true);
            }
            //alterar diretamente no filtro, por causa do useState local setHiddenFieldDataFiltro, que atualiza o react e o changeValue nao tem modificacao
            setFiltro({...filtro,dtIni:value['value']['dtIni'],dtFim:value['value']['dtFim'],opt_data_select:value,show_data_label:label})
        } else {
            if (field === "dtIni" || field === "dtFim") {
                label = "De: " + getDataText(state.formState.values.dtIni) + " Até: " + getDataText(state.formState.values.dtFim)
                changeValue(state, 'show_data_label', () => label);
            }
            changeValue(state, field, () => value)
        }

    }

    const handleFiltroSubmit = (value: FilterMovParams) => {
        console.log("handleFiltroSubmit", value);
        value.tipoMov = tipoMovState.row.descricao;
        setFiltro(value)
        setShowFormFiltro(false);
    }

    const List = () => {
        return (
            <ViewList
                displayWidth={window.innerWidth}
                title={tipoMovState.row.detalhes}
                row={row}
                showAlert={showAlert}
                closeAlert={() => setShowAlert(false)}
                msg={msg}
                status={status}
                elevation={1}
                getRowId={(row) => row._id}
                handleOnChange={handleAlterar}
                actionsOnkeyEnter={handleAlterar}
                showSearchContainer={true}
                fontSize={20}
                setTextSearch={() => { }}
                textSearch={""}
                multFieldSearch={true}
                fieldSearch={["pessoa.nome", "codigo"]}
                orderBy="codigo"
                columns={getColumn()}
                rows={rowGroup.rows}
                loading={loadingRows}
                setRow={handleAlterar}
                changeList={changeList}
                buttonNew={{
                    show: true,
                    onClick: handleNovo
                }}
                buttonRefresh={{
                    show: true,
                    onClick: () => handleRead()
                }}
                buttonMenu={{
                    show: false,
                    icon: <ListAlt />,
                    label: "Configuracoes",
                    menu: [
                        {
                            label: "Fechar Movimentos Abertos",
                            icon: <Close />,
                            onClick: () => movActions.scriptFecharMovsAbertos()
                        }
                    ]
                }}
                ListItemTextPrimary={(row: Movimentacao) => <Typography component={"span"}>{row.pessoa.nome}</Typography>}
                ListItemTextSecondary={(row: Movimentacao) =>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Typography component={"span"}>{row.codigo}</Typography>
                        <Typography component={"span"}>{formatMoney(row.fechamento.total)}</Typography>
                    </Box>
                }
                ViewBeforeGridList={GridStatusMov}
                hidenGridNoData
                showFullFiltroForm={true}
                fullFiltroFormParams={{
                    showFormFiltro: showFormFiltro,
                    listFieldShow: [
                        { label: "Período: ", name: "show_data_label", handleOnClick: () => setShowFormFiltro(true) },
                        { label: "Funcionário: ", name: "funcionario.nome", handleOnClick: () => setShowFormFiltro(true) },
                    ],
                    form: {
                        contentForm: [
                            { fieldName: "opt_data_select", label: "Periodo das vendas", type: "autocomplete", key: "opt_data_select", colunsXS: 12, colunsSM: 12, colunsMD: 6, list: listDataOpt, labelAutocomplete:"label", handleChangeMutator: (mutator, values, formValues) => mutator(values, "opt_data_select") },
                            { fieldName: "dtIni", label: "Data de:", type: "data", key: "dtIni", colunsXS: 12, colunsSM: 6, colunsMD: 3, hidden: hiddenFieldDataFiltro, handleChangeMutator: (mutator, values, formValues) => mutator(values, "dtIni") },
                            { fieldName: "dtFim", label: "Até:", type: "data", key: "dtFim", colunsXS: 12, colunsSM: 6, colunsMD: 3, hidden: hiddenFieldDataFiltro, handleChangeMutator: (mutator, values, formValues) => mutator(values, "dtFim") },
                            { fieldName: "show_data_label", label: "Data Text", type: "text", key: "show_data_label", colunsXS: 12, colunsSM: 12, colunsMD: 6, hidden: true },
                            {
                                fieldName: "funcionario.nome", label: "Funcionário", type: "select-dialog", key: "funcionario", colunsXS: 12, colunsSM: 12, colunsMD: 6,
                                handleOnClickShow: () => funcionarioActions.setShowSelectModal(true),
                                handleOnClickRemove: (v, mutator) => {
                                    mutator&&mutator({}, "funcionario")
                                },
                                showButtonLimparSelectDialog: true,
                                ViewSelecionarDialog: (props: any) => <SelecionarFuncionario handleConfirmar={
                                    (func) => {
                                        console.log("selecionar funcionario", [props, func])
                                        funcionarioActions.setShowSelectModal(false);
                                        props.handleMutator(func, "funcionario");
                                    }
                                } />,
                                handleChangeMutator: handleMutatorFiltro,
                            },
                        ],
                        buttonActions: [
                            { label: "Aplicar Filtro", icon: <Search />, color: "primary", variant: "outlined", type: "submit", disableType: "padraoForm" },
                            /* { label: "Load Itens", icon: <Search />, color: "primary", variant: "outlined", type: "button",handleOnClick:(values)=>itemCartProvider.readAllItensMov(values) }, */
                        ],
                        row: filtro,
                        handleMutator: handleMutatorFiltro,
                        handleOnSubmit: handleFiltroSubmit,
                        handleCancel: () => { },

                    }
                }}
                handleShowFiltroForm={() => setShowFormFiltro(!showFormFiltro)}
            />
        )
    }

    return (
        <div className="modulo">
            {/* <Cadastro /> */}
            <MovCadastroView/>
            <List />
        </div>
    )

}

export default connect(mapStateToMovProps, mapDispatchToMovProps)(memo(MovList));

export const handleShowModalCadMov = (row:Movimentacao,set:boolean) => {
    store.dispatch(movController.reducer.actions.set(row));
    store.dispatch(movController.reducer.actions.setShowCadModal(true))
}